import { createSlice } from '@reduxjs/toolkit'
import type { PayloadAction } from '@reduxjs/toolkit'
import { PSS_CONFIG_FALLBACK } from '@/constants'
import {
    PaySmallSmallCreditScore,
    PaySmallSmallCreditConfig,
    Borrower,
    CreditAllocationInfo,
    OutstandingCreditInfo,
    PaySmallSmallCreditLimitPercentage,
} from '@/types/transactions'

export interface PaySmallSmallState {
    userHasOverdueDebt: boolean
    creditScore: PaySmallSmallCreditScore | null
    config: PaySmallSmallCreditConfig | null
    creditAllocationData: CreditAllocationInfo | null
    borrower: Borrower | null
    outstandingCreditInfo: OutstandingCreditInfo | null
    creditLimits: {
        monthlyLimit: number
        weeklyLimit: number
        dailyLimit: number
        remainingLimit: number
    }
    creditLimitPercentage: PaySmallSmallCreditLimitPercentage | null
}

const initialState: PaySmallSmallState = {
    userHasOverdueDebt: false,
    creditScore: null,
    config: PSS_CONFIG_FALLBACK,
    creditAllocationData: null,
    borrower: null,
    outstandingCreditInfo: null,
    creditLimits: {
        dailyLimit: 0,
        weeklyLimit: 0,
        monthlyLimit: 0,
        remainingLimit: 0,
    },
    creditLimitPercentage: null,
}

export const paySmallSmallSlice = createSlice({
    name: 'paySmallSmallReducer',
    initialState,
    reducers: {
        setState: (state, action: PayloadAction<Partial<PaySmallSmallState>>) => {
            state.userHasOverdueDebt = action.payload.userHasOverdueDebt ?? state.userHasOverdueDebt
            state.config = action.payload.config ?? state.config
            state.creditAllocationData = action.payload.creditAllocationData ?? state.creditAllocationData
            state.borrower = action.payload.borrower ?? state.borrower
            state.creditScore = action.payload.creditScore ?? state.creditScore
            state.outstandingCreditInfo = action.payload.outstandingCreditInfo ?? state.outstandingCreditInfo
            state.creditLimits = action.payload.creditLimits ?? state.creditLimits
            state.creditLimitPercentage = action.payload.creditLimitPercentage ?? state.creditLimitPercentage
        },
        resetState: () => initialState,
    },
})

export const paySmallSmallActions = paySmallSmallSlice.actions
export type PaySmallSmallActions = typeof paySmallSmallActions
export default paySmallSmallSlice.reducer
